/**
 * We need to combine the reducers from other files into a root reducer here
 *
 * We also need to re-export all the actions exported by the other slice reducers
 */
import { configureStore } from '@reduxjs/toolkit';
import modalHandlerReducer from './modalHandlerReducer';
import zipCodeReducer from './zipCodeReducer';
import filtersReducer from './filtersReducer';
import { IS_TESTING_ENVIRONMENT } from '../constants/environment';
import offersReducer from './offersReducer';
import dealerContextReducer from './dealerContextReducer';

export const store = configureStore({
  reducer: {
    modalState: modalHandlerReducer,
    filters: filtersReducer,
    zipCodeState: zipCodeReducer,
    offersState: offersReducer,
    dealerContext: dealerContextReducer,
  },
  devTools: IS_TESTING_ENVIRONMENT,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
